import combineReducers from 'redux/lib/combineReducers';

import customer from './customer';
import tag from './tag';

export default combineReducers({
  customer,
  tag, 
});
